/* eslint-disable */
export function getenv<T = string>(key: string): T {
    const windowV = global ? (<any>global).window : window;
    const value = windowV.env[key];
    if (process.env.NODE_ENV === "development") {
        if (value === undefined || value === null) {
            throw new Error(
                `You must add '${key}' environment variable to the ./config.js file and the configuration manager`,
            );
        }
    }
    return value;
}
